var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close-issue-wrap"},[_c('span',[_vm._v("关闭issue")]),_c('span',{staticClass:"end-conversation"},[_vm._v("结束本轮对话")])])}]

export { render, staticRenderFns }